// extracted by mini-css-extract-plugin
export default {"container":"InvitedActionsModal_container__OQDw9","horizontalLine":"InvitedActionsModal_horizontalLine__1YiMi"};